import { api } from "@/lib/api";
import { isOffline } from "@/lib/offlineCache";

// Préchargement des documents à récupérer attribués au chauffeur (liste + détail de chaque établissement), mis en cache par l'intercepteur API.
export async function prefetchPickups() {
  if (isOffline() || (typeof navigator !== "undefined" && navigator.onLine === false)) return;
  try {
    const { data } = await api.get("/requests/grouped");
    if (data?.fromCache) return;
    await Promise.allSettled([api.get("/requests/mine"), ...(data?.groups || []).filter((g) => g.establishment_id).map((g) => api.get(`/requests/by-establishment/${g.establishment_id}`))]);
  } catch (_) {}
}
